import React from "react";
import MapList from './MapList.jsx';

export default class ShippingPlaces extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showOptions: this.props.showOptions
		};
	}

	componentWillReceiveProps = (nextProps) => {
		if (!nextProps.selectedPlaceId)
		this.setState({ showOptions: nextProps.showOptions });
	}

	render = () => {
		let T = window.Texts.checkout;
		let selectedPlace = (this.props.selectedPlaceId) ? this.props.places.find((place) => {
			return place.store.id == this.props.selectedPlaceId;
		}) : null;
		return (
			<div className="delivery-option">
				<div className="select-box">
					<a href="#" className="select" data-toggle="" aria-expanded="false" onClick={(e) => { this.setState({ showOptions: !this.state.showOptions }); e.preventDefault(); }}>{(selectedPlace) ? selectedPlace.store.title : T.selectStore}</a>
					{this.state.showOptions ?
						<div className="options" style={{ display: 'block' }}>
							<div className="points-list">
								{this.props.places.map((place) => (
									<div className="option" key={"place" + place.store.id}>
										<h4 onClick={() => { this.setState({ showOptions: !this.state.showOptions }); this.props.onChange(place.store.id); }}>{place.store.title}</h4>
										<div className="data">
											<div className="address">
												<p>
													{place.store.contact.address}
													<br />{place.store.title}
													<br />{place.store.contact.phone}
												</p>
											</div>
											<div className="open-hours">
												<p> <strong>{T.openHours}</strong> {place.store.displayOpeningHours}</p>
											</div>
										</div>
									</div>)
								)}
							</div>
							<MapList places={this.props.places} controlsEnabled={true} defaultZoom={10}/>
						</div> : null}

				</div>
				{(selectedPlace) ?
					<div className="details" style={{ display: 'flex' }}>
						<div className="address">
							<p>{selectedPlace.store.title}<br /> {selectedPlace.store.contact.address} <br />{selectedPlace.store.contact.phone}</p>
							<p className="open-hours"><strong>{T.openHours}</strong>{selectedPlace.store.displayOpeningHours}</p>
						</div>
						<div className="map" style={{ width: '150px', height: '150px',position:'relative' }}>
							<MapList places={[selectedPlace]} controlsEnabled={false} defaultZoom={18}/>
						</div>
					</div> : null}

			</div>);
	}
}